import createStyles from '@material-ui/core/styles/createStyles';
import {WithStyles} from '@material-ui/core/styles/withStyles';

export const styles = (theme) => createStyles({});

export type Styles = WithStyles<typeof styles>;
